import { wrapCall, callGet, callPost, callPut, callDelete } from './helpers'

//* ~~~~~~ NOTES ROUTES ~~~~~~

// Get agent notes
export const getNotes = async () => {
  return (await wrapCall({
    method: callGet,
    uri: '/notes/pages'
  })) as APIAgentNote
}

// Create a new note
export const postNote = async (data: AgentNoteCreate) => {
  return (await wrapCall({
    method: callPost,
    uri: '/notes/pages',
    data
  })) as APIAgentNote
}

// Update a note
export const putNote = async (id: string, data: AgentNoteCreate) => {
  return (await wrapCall({
    method: callPut,
    uri: `/notes/pages/${id}`,
    data
  })) as APIAgentNote
}

// delete a note
export const deleteNote = async (id: string) => {
  return (await wrapCall({
    method: callDelete,
    uri: `/notes/pages/${id}`
  })) as APIAgentNote
}
